import { render } from "./SectionNavNoMenu.vue?vue&type=template&id=50be4168&scoped=true"
import script from "./SectionNavNoMenu.vue?vue&type=script&lang=js"
export * from "./SectionNavNoMenu.vue?vue&type=script&lang=js"

import "./SectionNavNoMenu.vue?vue&type=style&index=0&id=50be4168&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50be4168"]])

export default __exports__